/* eslint-disable import/no-unresolved */
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import isValidDomain from 'is-valid-domain';

import { ADD_DOMAIN_URL } from 'Apollo/Mutations';
import AddDomainModal from '../components/AddDomainModal';

const AddDomainModalContainer = ({
    visible, setVisible, refetchUserInfo, tenantId,
}) => {
    const [domainUrl, setDomainUrl] = useState('');
    const [domainError, setDomainError] = useState(false);
    const [isDomainValid, setIsDomainValid] = useState(false);

    /* apollo mutation to add domain */
    const [addDomainUrl, { loading: addDomainLoading }] = useMutation(ADD_DOMAIN_URL);

    const inputHandler = value => {
        setDomainUrl(value);
        if (value.trim() === '') {
            setDomainError(true);
        } else {
            setDomainError(false);
        }
    };

    const onBlurHandler = (event => {
        if (event.target.value.trim() === '') {
            setDomainError(true);
        } else {
            setDomainError(false);
        }

        if (event.target.value.trim() !== '' && !isValidDomain(domainUrl)) {
            setIsDomainValid(true);
        } else {
            setIsDomainValid(false);
        }
    });

    const onSave = async () => {
        const result = isValidDomain(domainUrl);
        setDomainError(false);
        if (!domainUrl || domainUrl.trim() === '') {
            setDomainError(true);
            return;
        }
        if (!result) {
            setIsDomainValid(true);
            return;
        }
        if (!domainError || !result) {
            let updatedUrl = 'https://';
            if (domainUrl.includes('https://')) {
                updatedUrl = domainUrl;
            } else {
                updatedUrl = updatedUrl.concat(domainUrl);
            }
            try {
                await addDomainUrl({
                    variables: {
                        input: {
                            domainURL: updatedUrl,
                            tenantId,
                        },
                    },
                });
                refetchUserInfo();
                setVisible(false);
            } catch (e) {
                //
            }
        }
    };
    return (
        <AddDomainModal
            domainUrl={domainUrl}
            setDomainUrl={setDomainUrl}
            onSave={onSave}
            domainError={domainError}
            visible={visible}
            setVisible={setVisible}
            setDomainError={setDomainError}
            addDomainLoading={addDomainLoading}
            onBlurHandler={onBlurHandler}
            isDomainValid={isDomainValid}
            inputHandler={inputHandler}
        />
    );
};

export default AddDomainModalContainer;
